module.exports = __webpack_public_path__ + "static/media/fried_eggplant.45558212.png";